/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'update-node-status-card';
const prefix = `${moduleName}.${componentName}`;

export const updateOperationLabel = `${prefix}.updateOperationLabel`;
export const updateOperationStartTimeLabel = `${prefix}.updateOperationStartTimeLabel`;
export const updateSuccessfulLabel = `${prefix}.updateSuccessfulLabel`;
export const updateStoppedLabel = `${prefix}.updateStoppedLabel`;
export const updateFailedLabel = `${prefix}.updateFailedLabel`;
export const suppressWarningHeader = `${prefix}.suppressWarningHeader`;
export const warningMessage = `${prefix}.warningMessage`;
export const viewTranscriptTooltipLabel = `${prefix}.viewTranscriptTooltipLabel`;
export const precheckCompletedLabel = `${prefix}.precheckCompletedLabel`;
export const precheckFailedLabel = `${prefix}.precheckFailedLabel`;
export const precheckSuccessfulLabel = `${prefix}.precheckSuccessfulLabel`;
export const restoreSuccessfulLabel = `${prefix}.restoreSuccessfulLabel`;
export const restoreFailedLabel = `${prefix}.restoreFailedLabel`;
export const restoreStoppedLabel = `${prefix}.restoreStoppedLabel`;
export const dryrunSuccessfulLabel = `${prefix}.dryrunSuccessfulLabel`;
export const dryrunFailedLabel = `${prefix}.dryrunFailedLabel`;

export const ENGLISH = {
    [updateOperationLabel]: 'Operation',
    [updateOperationStartTimeLabel]: 'Started',
    [updateSuccessfulLabel]: 'Update Successful',
    [updateFailedLabel]: 'Update Failed',
    [updateStoppedLabel]: 'Update Stopped',
    [suppressWarningHeader]: 'Suppress Warning',
    [viewTranscriptTooltipLabel]: 'View Transcript',
    [warningMessage]: 'Some Pre-checks completed with warnings. You can suppress them and continue with Update.',
    [precheckCompletedLabel]: 'Pre-check Completed',
    [precheckFailedLabel]: 'Pre-check Failed',
    [precheckSuccessfulLabel]: 'Pre-check Successful',
    [restoreSuccessfulLabel]: 'Restore Successful',
    [restoreFailedLabel]: 'Restore Failed',
    [restoreStoppedLabel]: 'Restore Stopped',
    [dryrunSuccessfulLabel]: 'Dry Run Successful',
    [dryrunFailedLabel]: 'Dry Run Failed',
};
